export type TDownloadItem = (url: string) => void;

export const downloadVideo: TDownloadItem = (url) => {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
